import { actions, response } from 'actions';
import { consoleLogger } from 'helpers';
import { Storage } from 'aws-amplify';

/**
 * プログラムファイルアップロード
 * @param  {object}  file         アップロードファイル
 * @param  {boolean} isUpdate     上書き:true, 新規アップロード:false
 * @param  {boolean} isSecondFile ファイル2:true, ファイル1:false
 * @return {object} 処理結果 
 */
export const uploadProgramFile = (file, isUpdate, isSecondFile = false) => async dispatch => {
  const num = isSecondFile ? 2 : 1;
  if (isSecondFile) {
    dispatch({
      type: actions.SET_PROGRESSRATE,
      progressRate: 0,
      num: num,
      total: 2, //アップロードファイル数
    });
  }
  return await new Promise((resolve) => 
    Storage.put(
      file.name, 
      file,
      { contentType: 'application/octet-stream',
        progressCallback(progress) {
          const progressRate = Math.floor((progress.loaded / progress.total) * 100);
          dispatch({
            type: actions.SET_PROGRESSRATE,
            progressRate: progressRate,
            num: num,
            total: 2, //アップロードファイル数
          });
        },
      }
    ).then(result => {
      consoleLogger(result);
      dispatch({
        type: actions.UPLOAD_PROGRAM_FILE,
        key: result.key, 
        size: file.size,
        lastModified: new Date(),
        isUpdate: isUpdate
      });
      resolve(response);
    }).catch(err => {
      // 予期せぬエラー
      consoleLogger(err.response);
      resolve({...response, status: 500, errcode: err.message});
    })
  );
};

/**
 * プログラムファイルを一覧取得する
 * @return {object} 処理結果 
 */
export const getProgramFiles = () => async dispatch => {
  return await new Promise((resolve) => 
    Storage.list(
      '',{ level: 'public' }
    ).then(result => {
      consoleLogger(result);
      const data = result.filter((item) => item.key !== '');
      dispatch({
        type: actions.FETCH_PROGRAM_FILES,
        items: data,
      });
      resolve({...response, count: data.length, items: data});
    }).catch(err => {
      // 予期せぬエラー
      consoleLogger(err.response);
      resolve({...response, status: 500, errcode: err.message });
    })
  );
};

/**
 * 指定したファイル名を削除する
 * @param  {string} key ファイル名
 * @return {object} 処理結果 
 */
export const deleteProgramFile = (key) => async dispatch => {
  return await new Promise((resolve) => 
    Storage.remove(
      key, {level: 'public'}
    ).then(result => {
      consoleLogger(result);
      dispatch({
        type: actions.DELETE_PROGRAM_FILE,
        key: key
      });
      resolve({...response});
    }).catch(err => {
      // 予期せぬエラー
      consoleLogger(err.response);
      resolve({...response, status: 500, errcode: err.message });
    })
  );
};